import { render, staticRenderFns } from "./UserPhoneBindModal.vue?vue&type=template&id=2b5629ac&"
import script from "./UserPhoneBindModal.vue?vue&type=script&lang=js&"
export * from "./UserPhoneBindModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports